import React from 'react';
import { createRoot as reactCreateRoot } from 'react-dom/client';
import './index.scss';
import AkItunesFeed from './AkItunesFeed';
import packageJson from '../package.json'

const { name: APP_NAME, version: APP_VERSION } = packageJson

navigator.sendBeacon(
  'https://api.apps.austauschkompass.de/' + APP_NAME + '/track',
  JSON.stringify({ version: APP_VERSION, url: document.location.href })
)

export const createRoot = (el) => {
  const root = reactCreateRoot(el)
  return {
    render: (options) => {
      root.render(
        <React.StrictMode>
          <AkItunesFeed {...options} />
        </React.StrictMode>
      )
    },
    unmount: root.unmount,
  }
}
